import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import "./css/piechart.css"

const Piechart = (tokenomicsData) => {

  const [state, setState] = useState({
    series: [parseInt(tokenomicsData.tokenomicsData[0]?.percentage), parseInt(tokenomicsData.tokenomicsData[1]?.percentage), parseInt(tokenomicsData.tokenomicsData[2]?.percentage), parseInt(tokenomicsData.tokenomicsData[3]?.percentage)],
    options: {
      chart: {
        width: '100%',
        type: 'pie',
        background: {
          gradient: {
            type: 'linear',
            shadeIntensity: 0.5,
            gradientToColors: ['#ff7f50', '#6a5acd'],
            opacityFrom: 1,
            opacityTo: 0.5,
            stops: [0, 100],
          },
        },
      },
      labels: ['Private Sale', 'Pre Sale', 'Public Sale', 'Other'],
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        labels: {
          colors: ['#fff'],
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '14px',
          colors: ['#fff'],
        },
        dropShadow: {
          enabled: false,
        },
        offsetY: 10,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10,
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              labels: {
                colors: ['#fff'],
              },
            },
          },
        },
      ],
    },
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={state.options} series={state.series} type="pie" width={`100%`} />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Piechart;
